import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from './../redux/hooks';
import { useTheme } from '../themeContext';

// -- Redux

import { setSideBarMenu, setDashboardSection } from '../redux/features/general/navigation';

// -- Components

import Container from '../components/settings/Container';
import NavBar from '../components/general/navBar/NavBar';
import DoctorSettings from '../components/doctor/navigation/navBar/Settings';
import menuItems from '../util/navigation/sidebarMenu/settings';
import Sidebar from '../components/general/navigation/Sidebar';
import LockScreenWarning from '../components/lockScreen/warning/LockScreenWarning';
import SecurityPin from '../components/doctor/dashboard/popups/SecurityPin';
import LanguagePopup from '../components/general/popups/LanguagePopup';
import Page from '../components/general/containers/Page';
import DeleteAccountPopup from '../components/general/popups/DeleteAccountPopup';

const Settings: React.FC = () => {

const dispatch = useAppDispatch();
const navigate = useNavigate();
const { t } = useTranslation();
const { section: currentSectionFromUrl } = useParams<{ section?: string }>();

const colors = useAppSelector(state => state.theme.colors);

const section = useAppSelector(state => state.navigation.section);

const isSecurityPinPopupOpened = useAppSelector(state => state.navigation.isSecurityPinPopupOpened);
const isLockScreenWarningPopupOpened = useAppSelector(state => state.navigation.isLockScreenWarningPopupOpened);
const isLanguagePopupOpened = useAppSelector(state => state.navigation.isLanguagePopupOpened);
const isDeleteAccountPopupOpened = useAppSelector(state => state.navigation.isDeleteAccountPopupOpened);

// --

useEffect(() => {
    dispatch(setSideBarMenu(menuItems(t)));
}, [t, dispatch]);

// FIX: Add effect to sync the URL section with Redux state, similar to Dashboard.tsx
useEffect(() => {
    const settingsMenuItems = menuItems(t);
    if (currentSectionFromUrl) {
        // Update the redux state to reflect the section from the URL
        dispatch(setDashboardSection(currentSectionFromUrl));
    } else if (settingsMenuItems.length > 0) {
        // If no section is in the URL, navigate to the first one by default
        navigate(`/settings/${settingsMenuItems[0].section}`, { replace: true });
    }
}, [currentSectionFromUrl, dispatch, navigate, t]);

// --

return (
<Page>

    <NavBar>
        <DoctorSettings /> 
    </NavBar>

    <Sidebar /> 

    <Container />

    {isLockScreenWarningPopupOpened && <LockScreenWarning />}
    {isSecurityPinPopupOpened && <SecurityPin />}
    {isLanguagePopupOpened && <LanguagePopup />}
    {isDeleteAccountPopupOpened && <DeleteAccountPopup />}

</Page>
);
};

export default Settings;